import {
  LayoutGrid,
  List,
  Expand,
  Shrink,
  RotateCcw,
  SlidersHorizontal,
  X,
} from "lucide-react";

import { useState } from "react";

import ProjectSearch from "./ProjectSearch";
import ProjectFilters from "./ProjectFilters";

const ProjectToolbar = ({
  search,
  setSearch,
  filters,
  setFilters,
  onFullscreen,
  isFullscreen,
}) => {
  const [showFilters, setShowFilters] = useState(false);

  const clearFilters = () => {
    setSearch("");

    setFilters({
      status: "",
      priority: "",
      executionMode: "",
    });
  };

  return (
    <div
      className={
        isFullscreen
          ? "p-6 border-b"
          : "p-5"
      }
    >

      {/* Top Row */}
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">

        <div>
          <h2 className="text-xl font-semibold text-gray-800">
            Projects
          </h2>

          <p className="text-sm text-gray-500 mt-1">
            Manage and track all your projects
          </p>
        </div>

        <div className="flex items-center gap-2">


          {/* Filter */}
          <button
            onClick={() =>
              setShowFilters((prev) => !prev)
            }
            className="flex items-center gap-2 px-3 py-2 rounded-lg border hover:bg-gray-100 transition"
            title="Filter"
          >
            {showFilters ? (
              <X size={18} />
            ) : (
              <SlidersHorizontal size={18} />
            )}

            <span className="hidden sm:block">
              {showFilters
                ? "Close Filter"
                : "Filter"}
            </span>
          </button>

          {/* Fullscreen / Exit Fullscreen */}
          <button
            onClick={onFullscreen}
            className="p-2 rounded-lg border hover:bg-gray-100 transition"
            title={
              isFullscreen
                ? "Exit Fullscreen"
                : "Fullscreen"
            }
          >
            {isFullscreen ? (
              <Shrink size={18} />
            ) : (
              <Expand size={18} />
            )}
          </button>

        </div>
      </div>

      {/* Bottom Row */}
      <div className="flex flex-col xl:flex-row xl:items-center xl:justify-between gap-4 mt-5">

        <ProjectSearch
          search={search}
          setSearch={setSearch}
        />

        {showFilters && (
          <div className="flex flex-wrap items-center gap-3">

            <ProjectFilters
              filters={filters}
              setFilters={setFilters}
            />

            <button
              onClick={clearFilters}
              className="
                flex
                items-center
                gap-2
                px-4
                py-2
                rounded-lg
                border
                text-gray-600
                hover:bg-gray-100
                transition
              "
            >
              <RotateCcw size={16} />
              Reset
            </button>

          </div>
        )}

      </div>

    </div>
  );
};

export default ProjectToolbar;